interface arrayData {
    name:string;
    _id:string;
    profile_image?:string;
}

interface TooltipData {
    list :arrayData[]
	styles?:string;
	position?: string;
}

function Tooltip({list,styles="top-full mt-2",position="-top-2"}:TooltipData) {
    return (
        <div className={`${styles} bg-[#0C111D] rounded-lg py-2 px-3 min-w-[122px] absolute z-10 left-1/2 transform -translate-x-1/2 hidden group-hover:block cursor-default`}>
            <span className={`${position} arrow-top w-0 h-0 block absolute left-1/2 transform -translate-x-1/2`}></span>
            <ul className="text-center">
                {list.length > 0 &&  list.map((item:any)=>(
                    <li className="text-xs text-white pb-1 last:pb-0" key={item?._id}>{item?.name}</li>
                ))}
            </ul>
        </div>
    )
}

export default Tooltip